import { Header } from 'components/Header/Header';
import { Footer } from 'components/Footer/Footer';
import { SubHeader } from 'components/SubHeader/SubHeader';
import { StepsSidebar } from 'components/StepsSidebar/StepsSidebar';
import { InfoSidebar } from 'components/InfoSidebar/InfoSidebar';
import { AppContainer } from 'components/Container';

import { appBackground, hideOnSmall } from './styles.module.scss';

export const AppLayout = ({ children }) => {
  return (
    <>
      <Header />
      <SubHeader />
      <div className={appBackground}>
        <AppContainer>
          <div className="row">
            <div className={`col xl3 l4 m12 s12 hide-on-small ${hideOnSmall}`}>
              <StepsSidebar />
            </div>
            <div role="main" className="col xl6 l8 m12 s12">
              {children}
            </div>
            <div className="col xl3 l12 m12 s12">
              <InfoSidebar />
            </div>
          </div>
        </AppContainer>
      </div>
      <Footer />
    </>
  );
};
